"use strict";
module.exports = validate20;
module.exports.default = validate20;
var schema22 = { "$schema": "http://json-schema.org/draft-07/schema#", "additionalProperties": false, "properties": { "session": { "additionalProperties": { "type": "string" }, "description": "Identify the user using a set of `$identityRepository/$userId` key/value pairs.\nUsually, one of the `$identityRepository` is `sessionId`.", "type": "object" }, "variables": { "additionalProperties": {}, "description": "List of XO context variables attached to the request. The variables will be resolved according\nto your configuration in the XO Console.", "type": "object" } }, "type": "object" };
function validate20(data, valCxt) {
    "use strict";
    ;
    if (valCxt) {
        var instancePath = valCxt.instancePath;
        var parentData = valCxt.parentData;
        var parentDataProperty = valCxt.parentDataProperty;
        var rootData = valCxt.rootData;
    }
    else {
        var instancePath = "";
        var parentData = undefined;
        var parentDataProperty = undefined;
        var rootData = data;
    }
    var vErrors = null;
    var errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for (var key0 in data) {
            if (!((key0 === "session") || (key0 === "variables"))) {
                var err0 = { instancePath: instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema22, data: data };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        if (data.session !== undefined) {
            var data0 = data.session;
            if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
                for (var key1 in data0) {
                    var data1 = data0[key1];
                    if (typeof data1 !== "string") {
                        var err1 = { instancePath: instancePath + "/session/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/session/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.session.additionalProperties.type, parentSchema: schema22.properties.session.additionalProperties, data: data1 };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err2 = { instancePath: instancePath + "/session", schemaPath: "#/properties/session/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.properties.session.type, parentSchema: schema22.properties.session, data: data0 };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.variables !== undefined) {
            var data2 = data.variables;
            if (data2 && typeof data2 == "object" && !Array.isArray(data2)) { }
            else {
                var err3 = { instancePath: instancePath + "/variables", schemaPath: "#/properties/variables/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.properties.variables.type, parentSchema: schema22.properties.variables, data: data2 };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
    }
    else {
        var err4 = { instancePath: instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.type, parentSchema: schema22, data: data };
        if (vErrors === null) {
            vErrors = [err4];
        }
        else {
            vErrors.push(err4);
        }
        errors++;
    }
    validate20.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validateSearchContextSchema.js.map